import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNewTranslation } from 'hooks/index'
import { ExportButton } from 'components/Shared/MuiTable/ActionButton'
import { theme } from 'theme'
import { GLOBAL_MODAL_TYPE, openModal } from 'state/constants'
import Divider from 'components/Divider'
import { REGISTRATION_STATUS, selectSelectedCampaignUuid } from 'state/review'
import { exportRegistrationsList } from 'state/registrations'
import ExportModal from 'components/Submissions/Review/common/ExportModal'
import { STATE_KEYS } from 'state/requests'
import { selectRequestsAreLoading, selectRegistrationsList, selectPriorityListRows } from 'state'
import styled from 'particles/themes/styled'
import SearchBar from 'components/Shared/MuiTable/SearchBar'

const ButtonContainer = styled.div`
    width: 84px;
`

const ButtonGroup = styled.div`
    display: flex;
    margin-left: 12px;
    gap: 8px;
`

const RootHeaderBar: React.FC = () => {
    const [newT] = useNewTranslation()
    const dispatch = useDispatch()
    const campaignUuid = useSelector(selectSelectedCampaignUuid)
    const registrations = useSelector(selectRegistrationsList)
    const priorityListRows = useSelector(selectPriorityListRows)
    const isRegistrationExportRequesting = useSelector(selectRequestsAreLoading([STATE_KEYS.ExportRegistrationResults]))
    const handleOnOpenModal = (type: GLOBAL_MODAL_TYPE) => (): void => {
        dispatch(openModal(type))
    }
    const disableExport = registrations.length <= 0 && priorityListRows.length <= 0
    const handleClickExport = (): void => {
        if (!campaignUuid) return

        dispatch(
            exportRegistrationsList({
                uuid: campaignUuid,
                status: REGISTRATION_STATUS.waitlisted,
            }),
        )
    }
    return (
        <>
            <ButtonGroup>
                <ButtonContainer>
                    <ExportButton
                        onClick={handleOnOpenModal(GLOBAL_MODAL_TYPE.REQUEST_EXPORT)}
                        isDisable={disableExport}
                    />
                </ButtonContainer>
                <SearchBar />
            </ButtonGroup>

            <Divider mx={theme.spacing.xxs} mt={theme.spacing.xxs} mb={'0px'} />

            <ExportModal
                tableTitle={`${newT('taskType.registration')} - ${newT('statusLabel.waitlist', 'Waitlist')}`}
                isRequesting={isRegistrationExportRequesting}
                onClickExport={handleClickExport}
            />
        </>
    )
}

export default RootHeaderBar
